import { EnrollmentTag } from '@zorro/clients';
import { $enum } from 'ts-enum-util';

export enum TagSelectionState {
  ALL = 'ALL',
  SOME = 'SOME',
  NONE = 'NONE',
}

export type EditEnrollmentTagsRecord = {
  onboardingPeriodId: string;
  fullName: string;
  enrollmentTags?: EnrollmentTag[];
};

export type TagStates = Record<string, TagSelectionState>;

export function getTagSelectionState(
  records: EditEnrollmentTagsRecord[],
  tag: EnrollmentTag
): TagSelectionState {
  const taggedCount = records.filter((record) =>
    record.enrollmentTags?.includes(tag)
  ).length;

  if (taggedCount === 0) {
    return TagSelectionState.NONE;
  }
  return taggedCount === records.length
    ? TagSelectionState.ALL
    : TagSelectionState.SOME;
}

export function mapEnrollmentTagRecordToTagStates(
  records: EditEnrollmentTagsRecord[]
): TagStates {
  return Object.fromEntries(
    $enum(EnrollmentTag)
      .getValues()
      .map((tag) => [tag, getTagSelectionState(records, tag)])
  );
}

export function getRecordEnrollmentTags(
  record: EditEnrollmentTagsRecord,
  tagStates: TagStates
): EnrollmentTag[] {
  return $enum(EnrollmentTag)
    .getValues()
    .filter(
      (tag) =>
        tagStates[tag] === TagSelectionState.ALL ||
        (tagStates[tag] === TagSelectionState.SOME &&
          Boolean(record.enrollmentTags?.includes(tag)))
    );
}

function getNextSelectionState(state: TagSelectionState): TagSelectionState {
  return $enum.mapValue(state).with({
    [TagSelectionState.SOME]: TagSelectionState.ALL,
    [TagSelectionState.ALL]: TagSelectionState.NONE,
    [TagSelectionState.NONE]: TagSelectionState.SOME,
  });
}

export function getNextTagState(
  current: TagSelectionState,
  initial: TagSelectionState
): TagSelectionState {
  const nextState = getNextSelectionState(current);

  return nextState === TagSelectionState.SOME &&
    initial !== TagSelectionState.SOME
    ? getNextSelectionState(nextState)
    : nextState;
}
